module.exports = __webpack_public_path__ + "static/media/user-default.9d1403c3.png";